import { create } from 'zustand'

interface IMyMonitoringSiteContextStore {
  isAdmin: boolean
  setIsAdmin: (isAdmin: boolean) => void
  reset: () => void
}

export const useMyMonitoringSiteContextStore = create<IMyMonitoringSiteContextStore>((set) => ({
  isAdmin: false,
  setIsAdmin: (isAdmin: boolean) => set({ isAdmin }),
  reset: () => set({ isAdmin: false })
}))
